export default "skymp5-front/1c1a2f681c2e09c52e62e2eea731fe11.wav";